import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { scanProducts, ScannedProduct } from '../utils/productScanner';
import { CheckCircleIcon, XIcon } from 'lucide-react';
const names = ['Carolina', 'Roberto', 'Valentina', 'Andrés', 'María', 'Diego', 'Camila', 'Felipe', 'Sofía', 'Matías', 'Daniela', 'Sebastián', 'Javiera', 'Tomás', 'Francisca', 'Nicolás', 'Catalina', 'Ignacio', 'Fernanda', 'Martín'];
const cities = ['Santiago', 'Valparaíso', 'Concepción', 'Vitacura', 'Arica', 'Viña Del Mar', 'Estación Central', 'Maipu', 'Las Condes', 'Temuco', 'Quinta Normal', 'La Serena', 'Rancagua', 'Punta Arenas', 'Antofagasta'];
function randomBetween(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
function safeProductTitle(title: string) {
  return (title || '').replace(/internal preview/gi, '').replace(/dynamic/gi, '').replace(/preview/gi, '').replace(/\s{2,}/g, ' ').trim();
}
export function SalesPop() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPop, setCurrentPop] = useState<{
    name: string;
    city: string;
    time: string;
    product: ScannedProduct;
  } | null>(null);
  const productsRef = useRef<ScannedProduct[]>([]);
  const hideTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const nextTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => {
    productsRef.current = scanProducts();
    const showRandomPop = () => {
      const products = productsRef.current;
      if (products.length === 0) return;
      const randomName = names[randomBetween(0, names.length - 1)];
      const randomCity = cities[randomBetween(0, cities.length - 1)];
      const minutesAgo = randomBetween(1, 15);
      const randomTime = `hace ${minutesAgo} minuto${minutesAgo === 1 ? '' : 's'}`;
      let selectedProduct = products[0];
      if (products.length === 2 && products[0].priceNumber === 27 && products[1].priceNumber === 17) {
        selectedProduct = Math.random() < 0.7 ? products[0] : products[1];
      } else if (products.length > 1) {
        selectedProduct = products[randomBetween(0, products.length - 1)];
      }
      setCurrentPop({
        name: randomName,
        city: randomCity,
        time: randomTime,
        product: selectedProduct
      });
      setIsVisible(true);
      hideTimerRef.current = setTimeout(() => {
        setIsVisible(false);
        nextTimerRef.current = setTimeout(showRandomPop, randomBetween(25000, 45000));
      }, randomBetween(4000, 5000));
    };
    nextTimerRef.current = setTimeout(showRandomPop, randomBetween(8000, 15000));
    return () => {
      if (hideTimerRef.current) clearTimeout(hideTimerRef.current);
      if (nextTimerRef.current) clearTimeout(nextTimerRef.current);
    };
  }, []);
  return <AnimatePresence data-id="element-123">
      {isVisible && currentPop && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 400,
      damping: 25
    }} className="fixed bottom-24 md:bottom-6 left-4 md:left-6 z-[45] max-w-[340px] w-[calc(100%-2rem)] bg-white rounded-2xl shadow-2xl border border-zen-beige overflow-hidden flex" data-id="element-124">
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-slate-dark/40 hover:text-slate-dark transition-colors z-10" aria-label="Cerrar notificación" data-id="element-125">
            <XIcon className="w-4 h-4" data-id="element-126" />
          </button>

          <div className="w-24 bg-zen-beige p-2 flex items-center justify-center shrink-0" data-id="element-127">
            <img src={currentPop.product.thumbnailUrl} alt={safeProductTitle(currentPop.product.title)} className="w-full h-auto object-cover rounded-lg shadow-sm" data-id="element-128" />
          </div>

          <div className="p-4 flex flex-col justify-center flex-1" data-id="element-129">
            <div className="flex items-center gap-1.5 mb-1" data-id="element-130">
              <CheckCircleIcon className="w-3.5 h-3.5 text-green-500" data-id="element-131" />
              <span className="text-[10px] font-bold text-slate-dark/60 uppercase tracking-wider" data-id="element-132">
                Compra Verificada
              </span>
            </div>

            <p className="text-sm text-slate-dark leading-snug mb-2" data-id="element-133">
              <span className="font-bold" data-id="element-134">{currentPop.name}</span> de{' '}
              {currentPop.city} compró{' '}
              <span className="font-medium text-slate-dark/80" data-id="element-135">
                {safeProductTitle(currentPop.product.title)}
              </span>
            </p>

            <div className="flex items-center justify-between mt-auto" data-id="element-136">
              <span className="text-[11px] text-slate-dark/50 font-medium" data-id="element-137">
                {currentPop.time}
              </span>
              <span className="text-xs font-bold text-green-700 bg-green-100 px-2 py-0.5 rounded-md" data-id="element-138">
                {currentPop.product.priceText}
              </span>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}